import { render, staticRenderFns } from "./No01.vue?vue&type=template&id=022fcd34&scoped=true"
import script from "./No01.vue?vue&type=script&lang=js"
export * from "./No01.vue?vue&type=script&lang=js"
import style0 from "./No01.vue?vue&type=style&index=0&id=022fcd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fcd34",
  null
  
)

export default component.exports